/* NOTIFICATION ACTIONS *******************************************************/

import { randomString } from 'util/string'

const NOTIFICATION_TIMEOUT = 10000 // time in msec

/**
*  {
*    uid: uniqe notification id, will be generated if not given
*    type:'ERROR', some notification/type
*    meta: {
*     uid: '0af48aea35fc958726c063cbc7c319f6',
*     someval: ''
*    }
*    message: "some message",
*    detail: file.name,
*    unstoppable: false,
*    stopped: false,
*    completed: false,
*    progress: 0,
*    onCancel: (notification)
*    timeout: true, // false, true, missing or time in msec
*    onDismiss: (notification) => {...},
*    onTimeout: (notification) => {...},
*    onPull: (notification) => {...},
*  }
**/
export const PUSH = 'notification/PUSH'
export const push = (notification) => {
  return dispatch => {
    notification.uid = notification.uid || randomString()

    dispatch({ type: PUSH, notification })
  }
}

/**
*  {
*    uid: uniqe notification id, will be generated if not given
*    onDismiss: (notification) => {...},
*    onPull: (notification) => {...},
*  }
**/
export const UPDATE = 'notification/UPDATE'
export const update = (notification) => {
  return dispatch => {
    dispatch({ type: UPDATE, notification })
  }
}

/**
*   {
*    uid: uniqe notification id, will be generated if not given
*    onDismiss: (notification) => {...},
*    onPull: (notification) => {...},
*  }
**/
export const STOP = 'notification/STOP'
export const stop = (notification) => {
  return dispatch => {
    dispatch({ type: STOP, notification })
    dispatch(pull(notification))
  }
}

/**
*   {
*    uid: uniqe notification id, will be generated if not given
*    onDismiss: (notification) => {...},
*    onPull: (notification) => {...},
*  }
**/
export const DISMISS = 'notification/DISMISS'
export const dismiss = (notification) => {
  return dispatch => {
    dispatch({ type: DISMISS, notification })
    dispatch(pull(notification))
  }
}

/**
*  {
*    uid: uniqe notification id, will be generated if not given
*    onPull: (notification) => {...},
*  }
**/
export const PULL = 'notification/PULL'
export const pull = (notification) => {
  return dispatch => {
    dispatch({ type: PULL, notification })
  }
}



// WEBPACK FOOTER //
// ./src/app/react-redux/actions/notification.js